import React from "react";

/**
 * browser_preview surface only. Aspect ratio matches the finished 86mm x 52mm
 * landscape card. production_artwork is a separate future pipeline.
 */
import { CardTemplate } from "./CardTemplate";

export const CardSurface = ({ styleKey, side, data, logo, className = "", testId }) => (
  <div
    className={`w-full max-w-[360px] aspect-[86/52] rounded-xl overflow-hidden border border-[#0f3f2f]/12 bg-white shadow-[0_4px_14px_-10px_rgba(11,42,32,0.5)] ${className}`}
    data-testid={testId}
  >
    <CardTemplate styleKey={styleKey} side={side} data={data} logo={logo} />
  </div>
);
